module.exports = __webpack_public_path__ + "img/foa_03.5dbd9aae.png";